import React from "react";

const DropDown = ({ color, up }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      // `up` flips the chevron to point upward (for dropdowns that open upward,
      // e.g. the mobile bottom toolbar).
      style={up ? { transform: "rotate(180deg)" } : undefined}
    >
      <path
        d="M4 4.5L1 1.82411L1.36336 1.5L4 3.85179L6.63664 1.5L7 1.82411L4 4.5Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};

export default DropDown;
